document.addEventListener('DOMContentLoaded', async () => {
  const grid = document.getElementById('pv5-cs-grid');
  const totalEl = document.getElementById('pv5-cs-total');
  const savingsEl = document.getElementById('pv5-cs-savings');
  const atcBtn = document.getElementById('pv5-cs-atc');
  const section = document.getElementById('pv5-cross-sell');
  const dataEl = document.getElementById('pv5-cs-data');

  if (!grid || !section || !dataEl) return;

  const productData = JSON.parse(dataEl.textContent);

  function createConnector() {
    var div = document.createElement('div');
    div.className = 'pv5-cs__connector';
    div.setAttribute('aria-hidden', 'true');
    div.innerHTML = '<span class="pv5-cs__connector-icon">+</span>';
    return div;
  }

  function createCheckmark() {
    var div = document.createElement('div');
    div.className = 'pv5-cs__check';
    div.setAttribute('aria-hidden', 'true');
    div.innerHTML = '<svg width="14" height="14" viewBox="0 0 16 16" fill="none"><path d="M3 8.5L6.5 12L13 4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    return div;
  }

  function renderProducts(products) {
    if (products.length === 0) {
      section.style.display = 'none';
      return;
    }

    products.forEach(function(rec) {
      grid.appendChild(createConnector());

      var card = document.createElement('div');
      card.className = 'pv5-cs__card';
      card.dataset.variantId = rec.variantId;
      card.dataset.price = rec.price;
      card.dataset.selected = 'false';
      card.innerHTML =
        '<a href="' + rec.url + '" class="pv5-cs__img">' +
          '<img src="' + rec.image + '" alt="' + escapeHtml(rec.title) + '" loading="lazy" width="400" height="400">' +
        '</a>' +
        '<div class="pv5-cs__details">' +
          '<a href="' + rec.url + '" class="pv5-cs__name-link">' + escapeHtml(truncate(rec.title, 35)) + '</a>' +
          '<span class="pv5-cs__price">' + formatMoney(rec.price) + '</span>' +
          '<button type="button" class="pv5-cs__add-btn" data-variant-id="' + rec.variantId + '">' +
            '<span class="pv5-cs__add-btn-icon">+</span>' +
            '<span class="pv5-cs__add-btn-text">Add</span>' +
          '</button>' +
        '</div>';

      card.insertBefore(createCheckmark(), card.firstChild);
      grid.appendChild(card);
    });

    updateTotal();
  }

  try {
    var products = [];

    if (productData.source === 'metafield' && productData.crossSellProducts && productData.crossSellProducts.length > 0) {
      // --- Metafield-based: data already in JSON from Liquid ---
      products = productData.crossSellProducts.map(function(p) {
        return {
          title: p.title,
          url: p.url,
          price: p.price,
          image: p.image,
          variantId: p.variantId
        };
      });
    } else {
      // --- Fallback: Shopify Recommendations API ---
      var res = await fetch('/recommendations/products.json?product_id=' + productData.productId + '&limit=3');
      var data = await res.json();
      var recs = (data.products || []).slice(0, 2);

      products = recs.map(function(rec) {
        var variant = rec.variants[0];
        var priceCents = Math.round(parseFloat(variant.price));
        var imgUrl = rec.featured_image
          ? rec.featured_image.replace(/(\.[^.]+)$/, '_400x400$1')
          : '';
        return {
          title: rec.title,
          url: rec.url,
          price: priceCents,
          image: imgUrl,
          variantId: variant.id
        };
      });
    }

    renderProducts(products);

    // Add button click handler
    grid.addEventListener('click', function(e) {
      var addBtn = e.target.closest('.pv5-cs__add-btn');
      if (addBtn) {
        var card = addBtn.closest('.pv5-cs__card:not(.pv5-cs__card--main)');
        if (!card) return;
        var isSelected = card.dataset.selected === 'true';
        card.dataset.selected = String(!isSelected);
        var btnText = addBtn.querySelector('.pv5-cs__add-btn-text');
        var btnIcon = addBtn.querySelector('.pv5-cs__add-btn-icon');
        if (btnText && btnIcon) {
          btnText.textContent = !isSelected ? 'Added' : 'Add';
          btnIcon.textContent = !isSelected ? '\u2713' : '+';
        }
        updateTotal();
        return;
      }
    });

    // ATC handler
    atcBtn.addEventListener('click', async function() {
      var items = [];

      items.push({ id: productData.variantId, quantity: 1 });

      var qtyInput = document.querySelector('.pv5-qty__input');
      if (qtyInput) {
        items[0].quantity = parseInt(qtyInput.value) || 1;
      }

      grid.querySelectorAll('.pv5-cs__card[data-selected="true"]:not(.pv5-cs__card--main)').forEach(function(card) {
        var vid = card.dataset.variantId;
        if (vid) items.push({ id: parseInt(vid), quantity: 1 });
      });

      atcBtn.textContent = 'Adding...';
      atcBtn.disabled = true;

      try {
        var r = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        });
        if (r.ok) {
          atcBtn.textContent = '\u2713 Added!';
          atcBtn.style.background = '#2ecc71';
          document.dispatchEvent(new CustomEvent('cart:updated'));
          setTimeout(function() {
            atcBtn.textContent = 'Add Selected to Cart';
            atcBtn.style.background = '';
            atcBtn.disabled = false;
          }, 2000);
        } else {
          throw new Error();
        }
      } catch(err) {
        atcBtn.textContent = 'Error \u2014 Try Again';
        atcBtn.disabled = false;
        setTimeout(function() { atcBtn.textContent = 'Add Selected to Cart'; }, 2000);
      }
    });

  } catch(err) {
    section.style.display = 'none';
  }

  function updateTotal() {
    var total = productData.price;
    grid.querySelectorAll('.pv5-cs__card[data-selected="true"]:not(.pv5-cs__card--main)').forEach(function(card) {
      total += parseInt(card.dataset.price || 0);
    });
    if (totalEl) totalEl.textContent = formatMoney(total);
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function escapeHtml(str) {
    var d = document.createElement('div');
    d.textContent = str;
    return d.innerHTML;
  }

  function truncate(str, len) {
    return str.length > len ? str.substring(0, len) + '\u2026' : str;
  }
});
